<template>
    <!-- 01 : 数字化人才培养方向 -->
    <div class="solution-edu-part-1">
        <CommonComponentsSVGCommonBlueUpArrow class="solution-arrow-up education-slide-in-up" />
        <CommonComponentsUnionTitleWithNumber :union-title="data.partsInfo" class="education-slide-in-up" />
        <div v-if="!isMobile" class="solution-edu-part-1-container">
            <CommonComponentsCardTransform
                v-for="(cardItem, index) in data.part_1_Info"
                :key="index"
                class="solution-edu-part-1-card"
                :background-image="cardItem.bgImage"
                hide-arrow
            >
                <template #transform-card-title>
                    <div class="solution-edu-part-1-card-title">
                        {{ $t(cardItem.title) }}
                    </div>
                </template>
                <template #transform-card-follow>
                    <div class="solution-edu-part-1-card-subtitles">
                        <div
                            v-for="(cardSubtitleItem, subIndex) in cardItem.subTitle"
                            :key="subIndex"
                            class="solution-edu-part-1-card-subtitles-item"
                        >
                            <span class="solution-edu-part-1-card-subtitle-check">
                                <CommonComponentsSVGCommonCheckIcon />
                            </span>
                            <span>
                                {{ $t(cardSubtitleItem) }}
                            </span>
                        </div>
                    </div>
                </template>
            </CommonComponentsCardTransform>
        </div>
        <div v-if="isMobile" class="solution-edu-part-1-container-mobile customer-success-right-enter">
            <CommonComponentsSolutionsAcademyCustomChangingCards :card-list="data.part_1_Info" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import part1cardbg1 from '@assets/imgs/Solutions/Education/part1cardbg1.png';
    import part1cardbg2 from '@assets/imgs/Solutions/Education/part1cardbg2.png';
    import part1cardbg3 from '@assets/imgs/Solutions/Education/part1cardbg3.png';
    import { getIsMobileRef } from '~~/composables/useMatchRules.ts';

    const isMobile = getIsMobileRef();

    const data = {
        partsInfo: {
            key: '01',
            title: 'global_solutions_edu_title_1',
        },
        part_1_Info: [
            {
                title: 'global_solutions_edu_part_1_item_title_1',
                subTitle: [
                    'global_solutions_edu_part_1_item_subtitle_11',
                    'global_solutions_edu_part_1_item_subtitle_12',
                    'global_solutions_edu_part_1_item_subtitle_13',
                ],
                bgImage: part1cardbg1,
            },
            {
                title: 'global_solutions_edu_part_1_item_title_2',
                subTitle: [
                    'global_solutions_edu_part_1_item_subtitle_21',
                    'global_solutions_edu_part_1_item_subtitle_22',
                    'global_solutions_edu_part_1_item_subtitle_23',
                ],
                bgImage: part1cardbg2,
            },
            {
                title: 'global_solutions_edu_part_1_item_title_3',
                subTitle: [
                    'global_solutions_edu_part_1_item_subtitle_31',
                    'global_solutions_edu_part_1_item_subtitle_32',
                ],
                bgImage: part1cardbg3,
            },
        ],
    };
</script>

<style lang="less" scoped>
    .solution-edu-part-1 {
        // index.vue已有.solution-arrow-up的样式
        // 重新写一遍可以避免 [教育行业解决方案] 的流程图动画开始点提前
        .solution-arrow-up {
            margin: .convert(100px) [ @vw] 0;
            height: .convert(194px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                margin: 40px 0;
                height: 50px;
            }
        }
        &-container {
            display: flex;
            margin: .convert(80px) [ @vw] 0 .convert(100px) [ @vw] 0;
            gap: .convert(@flex-gap-lg) [ @vw];

            .solution-edu-part-1-card {
                width: .convert(440px) [ @vw];
                height: .convert(550px) [ @vw];
                font-family: HarmonyOS Sans SC;
                font-style: normal;
                font-weight: 400;
                line-height: normal;

                .solution-edu-part-1-card-title {
                    font-size: .convert(@font-size-title-xl) [ @vw];
                }

                .solution-edu-part-1-card-subtitles {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    margin-top: 12px;

                    font-size: .convert(20px) [ @vw];
                    line-height: .convert(38px) [ @vw]; /* 32px */

                    &-item {
                        display: flex;
                        align-items: center;
                        gap: 8px;

                        .solution-edu-part-1-card-subtitle-check {
                            display: flex;
                            align-items: center;
                            :deep(.svg-check-icon) {
                                width: .convert(18px) [ @vw];
                                height: .convert(20px) [ @vw];
                            }
                        }
                    }
                }
            }
        }
        &-container-mobile {
            width: 100%;
            margin-top: 15px;
            margin-bottom: 40px;
        }
    }

    :lang(en) {
        .solution-edu-part-1 {
            &-container {
                .solution-edu-part-1-card {
                    .solution-edu-part-1-card-title {
                        font-size: .convert(64px) [ @vw];
                    }
                }
            }
        }
    }
</style>
